//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 18.01.2016.
 */

(function () {
    'use strict';

    angular.module('container.layout')
        .factory('tabBarService', tabBarService);

    function tabBarService($rootScope, utilService, $state, $timeout, $q, localStorageService, userSettingsService, Event, HOME_REGION) {

        let service = {};


        let extensionRelatedTabs = [];
        let extensionUnrelatedTabs = [];

        let visibleTabCount = 0;

        let activeExtension = null;


        let loaded = false;
        let foreignRegionExtensionTabs = [];

        

        let splitTabs = function() {

            let allTabs = extensionRelatedTabs.concat(extensionUnrelatedTabs, foreignRegionExtensionTabs);
            let parts = _.partition(allTabs, function(tab) {
                return tab.state.split('.')[0] === activeExtension;
            });
            // dividing parts[0] into two different arrays naming extensionRelatedTabs and foreignRegionExtensionTabs based on the home region 
            extensionRelatedTabs = [];
            foreignRegionExtensionTabs = [];
            for (let part = 0; part < parts[0].length; part++) {
                let currentPart = parts[0][part];
                if (currentPart.params.srsngRegion && currentPart.params.srsngRegion !== HOME_REGION) {
                    foreignRegionExtensionTabs.push(currentPart);
                } else {
                    extensionRelatedTabs.push(currentPart);
                }
            }
            extensionUnrelatedTabs = parts[1];
        };

        let isTabEqual = function(tab1, tab2) {

            tab1 = angular.copy(tab1);
            tab1.id = null;
            delete tab1.params;
            tab1.stateHref = tab1.stateHref ? tab1.stateHref.split('?')[0] : null;

            tab2 = angular.copy(tab2);
            tab2.id = null;
            delete tab2.params;
            tab2.stateHref = tab2.stateHref ? tab2.stateHref.split('?')[0] : null;

            return angular.equals(tab1, tab2);
        };

        var saveTabs = function() {

            return userSettingsService.saveUserSetting('container', 'tabs', extensionRelatedTabs.concat(extensionUnrelatedTabs, foreignRegionExtensionTabs));
        };        

        $rootScope.$on('extensionService:activeExtensionChanged', function (evt, data) {

            activeExtension = data.extension.abbreviation.split('.')[0];

            if( loaded ) {
                splitTabs();

                notify();
            }
        });

        service.activateTab = function (tabId) {

            let tab = service.getTab(tabId);
            if( !tab) return;
            $state.go(tab.state, tab.params);

        };

        service.addTab = function (label, state, stateParams, position, openTab) {

            if( !loaded) return;

            stateParams = _.assign({id: 0}, stateParams, {tabId: utilService.generateUuid()});

            let newTab = new Tab(stateParams.tabId, label, state, stateParams);
            newTab.stateHref = $state.href(newTab.state, newTab.params);

            var allTabs = extensionRelatedTabs.concat(extensionUnrelatedTabs, foreignRegionExtensionTabs);
            var existingTab = allTabs.find(tab => isTabEqual(tab, newTab));

            let currentTab = newTab;
            //if tab is not existingTab, then based on HOME_REGION add the tab to either extensionRelatedTabs or foreignRegionExtensionTabs
            if (existingTab) {
                currentTab = existingTab;
            } else if(newTab.params.srsngRegion && newTab.params.srsngRegion !== HOME_REGION) {
                foreignRegionExtensionTabs.unshift(newTab);
            } else {
                extensionRelatedTabs.unshift(newTab);
            }

            this.changeTabState(currentTab.state, currentTab.params, openTab);

            //Introducing local storage to fix on refresh tab disappear issue.
            localStorageService.set("currentView", state.split('.')[0]);

            //condition for Multiregion environment
            if(newTab.params.srsngRegion) {
                userSettingsService.loadUserSetting('container', 'tabs').then((settings) => {
                    extensionRelatedTabs = [currentTab];
                    foreignRegionExtensionTabs = [];
                    extensionUnrelatedTabs = settings != null ? _.uniqBy(settings, (o)=>{return o.id}) : [];
                    splitTabs();
                    saveTabs();
                    notify();
                })
            } else {
                saveTabs();
                notify();
            }

            return currentTab.id;
        };

        service.removeTab = function (id, state, stateParams) {

            if( !loaded) return;

            let tabToRemove = service.getTab(id);
            if( !tabToRemove ) return;

            let tabToRemoveIndex = this.getTabPosition(id);

            _.remove(extensionRelatedTabs, function (tab) {
                return tab.id === id;
            });

            saveTabs();


            if( tabToRemove.stateHref === window.location.hash ) { //Removed tab was selected

                if (extensionRelatedTabs.length > 0) { //Further tabs present

                    //Open next tab to the right or (if none present) next tab to the left

                    let tabToOpen = extensionRelatedTabs[tabToRemoveIndex  - (tabToRemoveIndex < extensionRelatedTabs.length ? 0 : 1) ];

                    $timeout(function () {

                        $state.go(state ? state : tabToOpen.state, stateParams ? stateParams : tabToOpen.params);
                    });

                } else {
                    //No more tabs present => go to container
                    $timeout(function() {

                        $state.go(state ? state : 'container', state ? stateParams : null);
                    });

                }
            }

            notify();


            /*
             if( !nextTab ) return;

            $timeout( function() {
                let nextTabIndex = service.getTabPosition(nextTab.id);
                if (nextTabIndex >= visibleTabCount) {
                    let previousTab = extensionRelatedTabs[nextTabIndex - 1];
                    $timeout(function () { $state.go(previousTab.state, previousTab.params); });
                }
            });
            */

        };

        service.closeTab = function (id) {
            _.remove(extensionRelatedTabs, function (tab) {
                return tab.id === id;
            });
            saveTabs();
            notify();
        };

        service.removeTabs = function () {

            extensionRelatedTabs = [];
            saveTabs();
            notify();
        };

        service.moveTab = function (id, newPosition) {

            extensionRelatedTabs.splice(newPosition, 0, extensionRelatedTabs.splice(service.getTabPosition(id), 1)[0]);
            saveTabs();
            notify();
        };

        service.getTab = function (id) {
            return _.find(service.getTabs(), function (tab) { return tab.id === id; });
        };

        service.changeTabState = function (newState, stateParamsObject, openTab, labelName) {

            if (!newState || !stateParamsObject) return;

            // if (!utilService.isValidGuid(stateParamsObject.id)) { stateParamsObject.id = null; } we will implemented later

            let tab = service.getTab(stateParamsObject.tabId);

            if (tab) {

                let oldStateHref = tab.stateHref;
                let oldState = tab.state;
                tab.state = newState;
                tab.params = angular.copy(stateParamsObject);
                tab.stateHref = $state.href(tab.state, tab.params);

                if (typeof labelName !== "undefined") tab.label = labelName;

                if (newState !== oldState) { saveTabs(); }

                if (typeof openTab === "undefined" || openTab) $state.go(tab.state, tab.params);
                else if (window.location.hash === oldStateHref) $state.go(tab.state, tab.params, { notify: false });

            } else {
                if (typeof openTab === "undefined" || openTab) $state.go(newState, stateParamsObject);
            }

            notify();
        };

        service.changeTabLabel = function (stateParamsObject, labelName) {

            if (typeof labelName === "undefined" || labelName === null || labelName === "") return;

            let tab = service.getTab(stateParamsObject.tabId);
            if( !tab ) return;

            tab.label = labelName;
            saveTabs();
        };

        service.loading = false;

        service.loadTabs = function() {

            if( service.loading ) return;
            service.loading = true;
            $rootScope.$emit('tabBarService:loadingTabs', {loading: service.loading});

            var busyPromise = userSettingsService.loadUserSetting('container', 'tabs').then((settings) => {
                service.loading = false;
        
                extensionUnrelatedTabs = settings != null ? _.uniqBy(settings, (o)=>{return o.id}) : [];

                splitTabs();

                loaded = true;

                $rootScope.$emit('tabBarService:loadingTabs', {loading: service.loading});

                notify();

                return;
            }, function(error) {
                    console.error(error);
            });

            $rootScope.$emit('handleBusyPromise', busyPromise);
        };

        

        service.getTabs = function () {
            return extensionRelatedTabs;
        };

        service.getTabPosition = function (id) {
            return _.findIndex(service.getTabs(), function (tab) { return tab.id === id; });
        };

        service.setVisibleTabCount = function (count) {
            visibleTabCount = count;
        };

        $rootScope.$on(Event.USER_LOGGED_IN, function(evt, data) {

            service.loadTabs();
        });

        function notify() {
            $rootScope.$emit('tabBarService:tabsChanged');
        }

        return service;
    }

    function Tab(id, label, state, params) {
        this.id = id;
        this.label = label;
        this.state = state;
        this.params = params;
    };


})();
